/** Keeps Hannu's pending request until the blackout and its recorded reply finish. */
export class HannuShoutGate {
  private pending = false;

  reset(): void {
    this.pending = false;
  }

  step(requested: boolean, blackoutSpeaking: boolean): boolean {
    this.pending ||= requested;
    if (!this.pending || blackoutSpeaking) return false;
    this.pending = false;
    return true;
  }
}
